import { SopAPI } from './api';
import { clearCopiedDoc, copiedDocTitle, getCopiedDoc } from './docClipboard';

const cloneJson = (value, fallback) => {
  if (value == null) return fallback;
  try {
    return JSON.parse(JSON.stringify(value));
  } catch {
    return fallback;
  }
};

/**
 * Duplicate the in-app copied doc into `folderId` (null = unfiled).
 * No-ops when the clipboard is empty or not a doc.
 */
export async function pasteCopiedDoc({
  createDoc,
  moveDocToFolder,
  folderId = null,
} = {}) {
  const copied = getCopiedDoc();
  if (!copied?.docId || !createDoc) return null;

  let source;
  try {
    source = await SopAPI.get(copied.docId);
  } catch {
    clearCopiedDoc();
    return null;
  }

  if (!source?.id) {
    clearCopiedDoc();
    return null;
  }

  const doc = await createDoc({
    title: copiedDocTitle(source.title),
    icon: source.icon,
    body: cloneJson(source.body, []),
    tags: cloneJson(source.tags, []),
    visibility: source.visibility,
    variables: cloneJson(source.variables, []),
    variablesColumnWidths: Array.isArray(source.variablesColumnWidths)
      ? cloneJson(source.variablesColumnWidths, null)
      : null,
  });

  if (doc?.id && moveDocToFolder) {
    moveDocToFolder(doc.id, folderId || null);
  }

  return doc || null;
}
